import React from "react";
import { isMobileNativeApp } from '../../utils/mobileAppCheck';
import { getHeaderStatus } from "../../utils/is.after";
import { updateStandardDataLayerAttributes, setPageNameSiteSection, getCurrentPageNameSiteSection } from "../../analytics/adobe/index";
import { applyExitDataLayer } from "../../analytics/adobe/dataLayerValues";

class UnhappyCustomerPopup extends React.Component {

  state={
    pageName: '',
    siteSection: ''
  };

  componentDidMount() {
    let dataLayer=getCurrentPageNameSiteSection();
    if(dataLayer){
      this.setState({
        pageName: dataLayer.pageName,
        siteSection: dataLayer.siteSection
      });
    }
    const { pageName, siteSection }=applyExitDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  handleToggleNoSelection=(e)=>{
    const { pageName, siteSection }= this.state;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
    this.props.togglePopupWindow(false, e);
  };

  render (){
    const isHeaderShow=isMobileNativeApp()||getHeaderStatus(this.props.offerPreFilled.channelSource);
    let viewMobile = isHeaderShow?"display-block-popup":"display-none-popup";
    let viewMobileTop = isHeaderShow?"top-20":"";
    let viewDesktop = isHeaderShow?"display-none-popup":"display-block-popup";

    return (
      <div className={`modal unhappy-customer show`}>
        <div className={`modal-dialog ${viewMobileTop}`}>

          {this.props.isLogout ?
            <div role="dialog" aria-labelledby="dialog1TitleUnhappyJourney" aria-describedby="dialog1DescUnhappyJourney">
              <div className={`modal-content ${viewDesktop}`} id="dialog1DescUnhappyJourney">
                <div className="modal-header">
                  <div className="container">
                    <div className="d-flex flex-row-reverse margin-15">
                      <div className="p-0 window-btn-right">
                        <h3 className="header-font standard-blue text-right window-btn" value=""
                          onClick={(e) => this.handleToggleNoSelection(e)} tabIndex="0"
                          onKeyDown={e=> {
                            let key = e.keyCode;
                            key === 13 ? this.handleToggleNoSelection(e) : null;
                            key === 32 ? this.handleToggleNoSelection(e) : null;
                          }}>&times;</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`modal-body ${viewDesktop}`}>
                  <div className="row">
                    <div className="col max-auto text-center">
                      <p className="info-icon"></p>
                      <div className={`popup-section ${viewDesktop}`}>
                        <h3 className="your-loan-details">Are you sure you want to log out? </h3>
                        <p>If you do, your entries won't be saved.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`modal-footer btn-exit ${viewDesktop}`}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col- max-auto">
                      <button data-track="custom-links" type="button" className="btn-block undark-btn text-standard btn-relation-group" value=""
                        onClick={(e) => this.props.togglePopupWindow(false, e)}>Cancel
                      </button>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col- max-auto">
                      <button data-track="custom-links" type="button" className="btn-block btn-primary bg-standard btn-relation-group"
                        value="logOut" onClick={(e) => this.props.togglePopupWindow(true, e)}>Log out
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`modal-content  ${viewMobile}`}>
                <div className="container-fluid">
                  <div className="modal-main-xs">
                    <div className="pop-up-body-sm col-xs-6 col-sm-6 col-md-10">
                      <h4>Are you sure you want to log out?</h4>
                      <p className="p-txt">If you do, your entries won't be saved.</p>
                    </div>
                    <section className="row">
                      <div className="col-6 no-border-yes">
                        <div className="popup-no-yes-xs margin-15 text-center">
                          <div type="button" data-track="custom-links" className="no-yes" aria-label="Cancel" value="" onClick={(e) => this.props.togglePopupWindow(false, e)}>
                            <span aria-hidden="true">Cancel</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="popup-no-yes-xs margin-left-15 text-center">
                          <div type="button" data-track="custom-links" className="no-yes" aria-label="Logout" value="logOut" onClick={(e) => this.props.togglePopupWindow(true, e)}>
                            <span aria-hidden="true">Logout</span>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            :
            <div>
              <div className={`modal-content ${viewDesktop}`} id="dialog1DescUnhappyJourney">
                <div className="modal-header">
                  <div className="container">
                    <div className="d-flex flex-row-reverse">
                      <div className="p-0 window-btn-right">
                        <h3 className="header-font standard-blue text-right window-btn" value="" tabIndex="0"
                          onClick={(e) => this.handleToggleNoSelection(e)}
                          onKeyDown={e=> {
                            let key = e.keyCode;
                            key === 13 ? this.handleToggleNoSelection(e) : null;
                            key === 32 ? this.handleToggleNoSelection(e) : null;
                          }}>&times;</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`modal-body ${viewDesktop}`}>
                  <div className="row">
                    <div className="col max-auto text-center">
                      <p className="info-icon"></p>
                      <div className={`popup-section ${viewDesktop}`}>
                        <h3 className="your-loan-details">Are you sure you want to exit? </h3>
                        <p>If you exit, your entries won't be saved.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`modal-footer btn-exit ${viewDesktop}`}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col- max-auto">
                      <button type="button" data-track="custom-links" className="btn-block undark-btn text-standard btn-relation-group" value="" onClick={(e) => this.handleToggleNoSelection(e)}>Cancel</button>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col- max-auto">
                      <button type="button" data-track="custom-links" className="btn-block btn-primary bg-standard btn-relation-group" value="BacktoAccount" onClick={(e)=>this.props.togglePopupWindow(true, e)}>Exit</button>
                    </div>
                  </div>
                </div>
              </div>
                
              <div className={`modal-content ${viewMobile}`}>
                <div className="container-fluid">
                  <div className="modal-main-xs">
                    <div className="pop-up-body-sm col-xs-6 col-sm-6 col-md-10">
                      <h4>Are you sure you want to exit?</h4>
                      <p className="p-txt">If you exit, your entries won't be saved.</p>
                    </div>
                    <section className="row">
                      <div className="col-6 no-border-yes">
                        <div className="popup-no-yes-xs margin-15 text-center">
                          <div type="button" data-track="custom-links" className="no-yes" value="" aria-label="Cancel" onClick={(e) => this.handleToggleNoSelection(e)}>
                            <span aria-hidden="true">Cancel</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="popup-no-yes-xs margin-left-15 text-center">
                          <div type="button" data-track="custom-links" className="no-yes" aria-label="Exit" value="BacktoAccount" onClick={(e)=>this.props.togglePopupWindow(true, e)}>
                            <span aria-hidden="true">Exit</span>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default UnhappyCustomerPopup;
